import Name from './Name';

export { Name as LegislatorName };
